// extracted by mini-css-extract-plugin
module.exports = {"category":"styles_category__1SA4D","wrapper":"styles_wrapper__1AM7X","categoryWrapper":"styles_categoryWrapper__1MmnI","items":"styles_items__2xOlK","title":"styles_title__qEvdt"};